import { createSelector } from "@reduxjs/toolkit";
export const fanpage = (state) => state.fanpageReducer.fanpage;

const selectFanpage = (state) => state.fanpageReducer;
export const fanpageFull = createSelector(
  selectFanpage,
  (state) => state.fanpageFull
);
